export const MENU_ID = {
  KLAIM_TPA: 52,
  INSURANCE_PORTAL: 13,
  ANALYTICS_DASHBOARD: 58,
  INSURANCE_CLAIM_QC: 59,
};

export const URL_MENU = {
  INSURANCE_PORTAL: '/insurance-portal',
  HISTORY_CLAIM: '/history-claim',
  TPA: '/tpa-claims',
};
